import {
  Component,
  HostListener,
  OnInit
} from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {
    this.checkReveal();
  }

  @HostListener('window:scroll')
  onScroll(): void {
    this.checkReveal();
  }

  checkReveal(): void {
    const elements = document.querySelectorAll('.reveal');
    const windowHeight = window.innerHeight;

    elements.forEach((element: any) => {
      const position = element.getBoundingClientRect().top;

      if (position < windowHeight - 80) {
        element.classList.add('active');
      }
    });
  }

}